// extracted by mini-css-extract-plugin
module.exports = {"rolesFormContainer":"style_rolesFormContainer__jiQCo","form":"style_form__eujd0","checkBoxRow":"style_checkBoxRow__30Rkj"};